import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Check } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../data/site";

export default function Leistungen() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);

  return (
    <main data-testid="leistungen-page">
      <section className="border-b border-line">
        <div className="mx-auto max-w-[1600px] px-6 pb-20 pt-40 md:px-12 md:pt-52">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember">Leistungen</p>
            <h1 className="mt-8 font-display text-5xl font-black uppercase leading-[0.95] tracking-tighter text-bone md:text-8xl">
              Was wir<br />auf die<br />Beine stellen
            </h1>
            <p className="mt-10 max-w-xl text-base leading-relaxed text-ash md:text-lg">
              Vier Gewerke, ein Anspruch: Bauen in höchster handwerklicher Qualität — termintreu, transparent und mit 30 Jahren Erfahrung in jedem Detail.
            </p>
          </Reveal>
        </div>
      </section>

      {SERVICES.map((s, i) => (
        <section
          key={s.slug}
          id={s.slug}
          data-testid={`service-section-${s.slug}`}
          className={`border-b border-line ${i % 2 === 1 ? "bg-coal" : "bg-ink"}`}
        >
          <div className={`mx-auto grid max-w-[1600px] gap-0 lg:grid-cols-2 ${i % 2 === 1 ? "" : ""}`}>
            <div className={`relative min-h-[320px] overflow-hidden border-line lg:min-h-[560px] ${i % 2 === 1 ? "lg:order-2 lg:border-l" : "lg:border-r"}`}>
              <Reveal className="h-full" y={0}>
                <img
                  src={s.image}
                  alt={`${s.title} — Prott Bauunternehmung`}
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </Reveal>
              <div className="absolute left-0 top-0 border-b border-r border-line bg-ink px-5 py-3">
                <span className="font-mono text-sm text-ember">{s.nr}</span>
              </div>
            </div>

            <div className="flex flex-col justify-center px-6 py-16 md:px-12 md:py-24 lg:px-20">
              <Reveal>
                <h2 className="font-display text-4xl font-bold uppercase tracking-tighter text-bone md:text-5xl">{s.title}</h2>
                <p className="mt-4 font-display text-lg font-medium text-ember md:text-xl">{s.claim}</p>
                <p className="mt-6 max-w-lg text-base leading-relaxed text-ash">{s.desc}</p>
                <ul className="mt-10 space-y-4">
                  {s.scope.map((item) => (
                    <li key={item} className="flex items-center gap-4 border-b border-line pb-4 text-sm text-bone">
                      <Check size={16} weight="bold" className="shrink-0 text-ember" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/kontakt"
                  data-testid={`service-cta-${s.slug}`}
                  className="group mt-12 inline-flex items-center gap-3 border border-ember px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-ember transition-colors duration-300 hover:bg-ember hover:text-ink"
                >
                  {s.title} anfragen
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Reveal>
            </div>
          </div>
        </section>
      ))}

      <Marquee />
    </main>
  );
}
